// extracted by mini-css-extract-plugin
export default {"wrap":"KH-z","articleImagesWrap":"LH-z","articleImage":"MH-z","singleImage":"NH-z"};